import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, ReactNode } from "react";
export enum ComparisonLabel {
  EMR = "EMR",
  Valerie = "Valerie",
}
interface ComparisonContextValue {
  comparisonLabel: ComparisonLabel;
}
const ComparisonContext = createContext<ComparisonContextValue | undefined>(undefined);
export function ComparisonProvider(t0) {
  const $ = _c(5);
  const {
    comparisonLabel,
    children
  } = t0;
  let t1;
  if ($[0] !== comparisonLabel) {
    t1 = {
      comparisonLabel
    };
    $[0] = comparisonLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ComparisonContext.Provider value={t1}>{children}</ComparisonContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function useComparison() {
  const context = useContext(ComparisonContext);
  return context;
}